var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.223,
    height: 20,
    viewBox: "0 0 22.223 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Area",
    d: "M1,1V19H19V1H1M0,0H20V20H0Z",
    fill: "#d83236",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(1.29 2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_8f0231fe-9d36-4753-a5a4-625fa9b0ce9a",
    "data-name": "8f0231fe-9d36-4753-a5a4-625fa9b0ce9a",
    d: "M20,1.111H0A1.111,1.111,0,0,1-1.111,0,1.111,1.111,0,0,1,0-1.111H20A1.111,1.111,0,0,1,21.111,0,1.111,1.111,0,0,1,20,1.111Z",
    transform: "translate(-1.29 7.501)",
    fill: "#d83236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc942a45-25fa-4e6e-95e0-b7decc4b079c",
    d: "M20,1.111H0A1.111,1.111,0,0,1-1.111,0,1.111,1.111,0,0,1,0-1.111H20A1.111,1.111,0,0,1,21.111,0,1.111,1.111,0,0,1,20,1.111Z",
    transform: "translate(-1.29 0.834)",
    fill: "#d83236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2e7c2f22-a94a-426f-95a7-da40485dc149",
    "data-name": "2e7c2f22-a94a-426f-95a7-da40485dc149",
    d: "M13.5,1.111H0A1.111,1.111,0,0,1-1.111,0,1.111,1.111,0,0,1,0-1.111H13.5A1.111,1.111,0,0,1,14.611,0,1.111,1.111,0,0,1,13.5,1.111Z",
    transform: "translate(-1.29 14.168)",
    fill: "#d83236"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuRed);
export default __webpack_public_path__ + "static/media/ic_menu_red.eb740fbbefd63d5f35e4a6bcfdab0bb2.svg";
export { ForwardRef as ReactComponent };